export const termsParagraphStyle = { fontSize: '13px', lineHeight: 1.6, color: '#334155', textAlign: 'left', paddingRight: '8px' };
